<template>
  <v-icon
    x-small
    color="grey lighten-2"
    class="tooltip-indicator"
  >
    mdi-information-variant
  </v-icon>
</template>

<script>
export default {
  name: 'OlTti' /* Tooltipicon */
}
</script>

<style lang="scss" scoped>

</style>
